import { Action } from 'redux';

import { RunExtractRefresh } from '../../app/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';

export interface RunExtractRefreshAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function runExtractRefresh(tasks: IExtractTaskInfo[]): RunExtractRefreshAction {
  return {
    type: RunExtractRefresh,
    tasks
  };
}
